module.exports = __webpack_public_path__ + "img/06.e5960d0b.png";